<template>
    <div class="MarketSection">
        <!-- <section class="blockElement mainBanner whiteBG p-4 mb-4">
            <div class="inner-banner-custom justify-content-center row align-items-center">
                <div class="col-12 text-center">
                    <h3 class="mb-2">Market <span>News</span></h3>
                    <p>Stay up to date on the latest market action with our news section. We bring you the news that moves the markets, so that you can focus on making the most out of your trading.</p>
                </div> 
            </div>
        </section> -->  
        <div class="d-flex align-items-center justify-content-between mb-2" v-if="Object.keys(currentNews).length > 0 && currentNews.totalRecords > 0 ">
            <h2 class="subTitle">{{$t('news_marketnews')}}</h2>
        </div>
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader && (localNewsData.length == 0 || page <= 1)"></complete-loading>
        <section class=" ipbPopUp between-footer" id="singleNews" :class="{'d-none': (Object.keys(singleNews).length == 0)}"> 
            <div class="containerArea" v-if="Object.keys(singleNews).length">
                 <div class="row showNewPop mb-4">
                    <div class="col-12">
                    <!--====================FULL NEWS SECTION POP=============================-->
                        <div class="fullNewsSection show d-none news-modal-wrapper">
                            <div class="customPp">
                                <button @click.prevent="singleNews = {};toDivElement(lastId)" type="button" class="close d-flex align-items-center justify-content-center" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body-p whiteBG p-3">
                                <h4 class="my-1"  v-html="singleNews.title"></h4>
                                 <div class="date d-flex align-items-center ml-auto mb-2">{{dateFunction(singleNews.created)}}</div>

                                <div class="imgT d-inline-block my-3 news-modal-feature-img">
                                    <figure class="pr-3">
                                        <img :src="singleNews.fxImages.Url_Large" v-if="singleNews.image">
                                        <img :src="getImage(singleNews.tags,singleNews.title,singleNews._id)" v-else>
                                    </figure>
                                    <p v-html="singleNews.description"></p>
                                </div>
                                
                            </div>
                        </div>
                    <!--====================End FULL NEWS SECTION POP=============================-->
                    </div>
                </div>
            </div>
        </section>
        <div class="mb-3 tab-responsive customTab-show active" v-show="Object.keys(singleNews).length == 0">
            <div class="row no-gutters Records mb-4">
               <div class="col-md-6 pr-2 RecordsLeft">
                   <div class="card p-0 border-0 mb-0">
                       <div class="card-body p-0 border-0 mb-0" :id="'one'">
                           <div class="whiteBG p-3" v-if="localNewsData.length">
                               <figure>
                                    <img :src="localNewsData[0].image" v-if="localNewsData[0].image">    
                                    <img :src="getImage(localNewsData[0].tags,localNewsData[0].title,localNewsData[0]._id)" v-else>     
                                </figure>
                               <div class="RecordsBottom mt-3">
                                   <div class="d-flex justify-content-between incWdth">
                                        <!-- <h5 class="card-title mb-0" v-html="localNewsData[0].tags"></h5>  -->
                                        <div class="BlogTitleArea" @click.prevent="singleNews = localNewsData[0];toDivElement('singleNews');lastId = 'one'">
                                            <h4 class="RecordTitle BlogTitle mb-0"><a href="#" class="green" v-html="localNewsData[0].title"></a></h4>
                                        </div>
                                           
                                    </div>
                                    <p class="card-text mb-1" v-html="localNewsData[0].description.substring(0,150)+'...'" v-if="localNewsData[0].description"></p>
                                    <div class="date d-flex align-items-center justify-content-between">
                                        <div class="date d-flex align-items-center ">{{dateFunction(localNewsData[0].created)}}</div>
                                        <div class="newsSrc" v-if="localNewsData[0].source">
                                           <p class="sm mb-0">{{(localNewsData[0].source == 'FXS')?'Fx Street':(localNewsData[0].source == 'TE')?'Trading Economics':localNewsData[0].source}}</p>
                                        </div>
                                    </div> 
                                </div>
                           </div>
                       </div>
                   </div>
               </div> 
               <div class="col-md-6 RecordsRight pl-2">
                   <div class="card p-0 border-0 mb-0">
                       <div class="card-body p-0 border-0  mb-0">
                           <div class="whiteBG p-3" v-if="localNewsData.length">
                               <div class="row py-3 " :class="{'border-bottom':index < 3}" v-for="list,index in localNewsData" v-if="index > 0 && index < 4" :id="'three'+index">
                                   	<div class="col-md-4 pr-2">
                                   		<img :src="list.image" v-if="list.image">    
                                        <img :src="getImage(list.tags,list.title,list._id)" v-else>
                                   	</div>
                                   	<div class="col-md-8 pl-2">
                                       	<div class="d-flex justify-content-between incWdth">
                                            <div class="BlogTitleArea" @click.prevent="singleNews = list;toDivElement('singleNews');lastId = 'three'+index">
                                                <h4 class="RecordTitle mb-0 BlogTitle"><a href="#" class="green" v-html="list.title"></a></h4>
                                            </div>
                                            
                                        </div>
                                        <p class="card-text mb-1" v-html="list.description.substring(0,150)+'...'" v-if="list.description"></p>
                                        <div class="date d-flex align-items-center justify-content-between">
                                            <div class="date d-flex align-items-center ">{{dateFunction(list.created)}}</div>
                                            <div class="newsSrc" v-if="list.source">
                                                <p class="sm mb-0">{{(list.source == 'FXS')?'Fx Street':(list.source == 'TE')?'Trading Economics':list.source}}</p>
                                            </div>
                                        </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div> 
            </div>
            <div class="row FeaturedSection" :class="(!pageLoader && currentNews.totalRecords && (type == 'all')?(currentNews.totalRecords <= 10):currentNews.totalRecords == 0)?  'no_result_found' : ''">
                <div class="col-12 col-md-7 pr-2 ">
                    <div class="d-flex align-items-center justify-content-between mb-2" v-if="Object.keys(currentNews).length > 0 && currentNews.totalRecords > 0 ">
                        <h2  class="subTitle">{{$t('news_fearurednews')}}</h2>
                        <div class="newsCategory d-flex align-items-center">
                            <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('all')" :class="(type == 'all')?'active' : ''">{{$t('news_market')}}</a>
                            <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('currency')" :class="(type == 'currency')?'active' : ''">{{$t('edu_forex')}}</a>
                            <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('stock market')" :class="(type == 'stock market')?'active' : ''">{{$t('edu_indices')}}</a>
                            <a class="nav-link" href="#" v-on:click.prevent = "tabFunc('commodity')" :class="(type == 'commodity')?'active' : ''">{{$t('edu_commodities')}}</a>
                        </div>
                    </div>
                    <div class="row no-gutters"> 
                        <div class="col-12 col-lg-12 blogSection" v-for="(list,index) in currentNews.records" v-if="currentNews.totalRecords && currentNews.totalRecords > 0 && (type == 'all')?(index >= 10):true && (!pageLoader || page > 1)" :id="'all'+index"><!-- @click.prevent="callGetDetail(list)" -->
                            <div class="card newTrade p-0 border-0">
                                <div class="card-body py-3 px-0  border-0 border-bottom">
                                    <div class="row no-gutters px-3">
                                        <div class="col-md-4 pr-2">
                                            <img :src="list.image" v-if="list.image">
                                            <img :src="getImage(list.tags,list.title,list._id)" v-else> 
                                        </div>
                                        <div class="col-md-8 pl-2">
                                            <h4 class="mb-0 BlogTitle" @click.prevent="singleNews = list;toDivElement('singleNews');lastId = 'all'+index">
                                            	<a class="green" href="#">{{list.title}}</a> </h4>
                                            
                                            <span v-if="list.source != 'FXS'">
                                                <p class="card-text mb-1" :ref="'less'+index"><span v-html="list.description.substring(0,150)" v-if="list.description"></span></p>
                                            </span>
                                            <span v-else>
                                                <p class="card-text mb-1" :ref="'less'+index" >
                                                    <span v-html="(list.description != '' && list.description != null)? list.description.concat(list.summary).substring(0,150) : '-'"></span>
                                                </p>
                                            </span> 
                                            <div class="d-flex align-items-center justify-content-between">

                                                <div class="date d-flex align-items-center ">{{dateFunction(list.created)}}</div>
                                                <div class="newsSrc" v-if="list.source">
                                                    <p class="sm mb-0">{{(list.source == 'FXS')?'Fx Street':(list.source == 'TE')?'Trading Economics':list.source}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                       
                        <div class="col-12 mt-2 col-lg-12 whiteBG  p-3 AutoChartist RecordFound " v-if="!pageLoader && currentNews.totalRecords && (type == 'all')?(currentNews.totalRecords <= 10):currentNews.totalRecords == 0">
                            <div class="col-12 noRecordFound">
                                <img src="../../../../static/fxView/images/search.svg" alt="no record found"> <p><p>{{$t('thereIsNoRecord')}}</p></p>
                            </div> 
                        </div>
                        <div class="col-12">
                            <div class="loadMore mt-4 mt-md-5 text-center" v-if="currentNews.totalRecords && currentNews.totalRecords > 0 &&( id != '' || !pageLoader )">
                                <a href="#" class="common_btn btn_xs" v-on:click.prevent="id = ''; loadList()">{{$t('marin_loadmore')}}</a>
                                
                            </div>
                            <div class="loadMore mt-4 mt-md-5 text-center" v-else-if="currentNews.totalRecords && currentNews.totalRecords > 0 && pageLoader">
                                <a href="#" class="common_btn btn_xs">{{$t('marin_loadwait')}}</a>
                                
                            </div>
                        </div>
                    </div> 

                </div>
                <div class="col-12 col-md-5 pl-2">
                    <div class="d-flex align-items-center justify-content-between mb-2 " v-if="Object.keys(currentNews).length > 0 && currentNews.totalRecords > 0 ">
                        <h2 class="subTitle">{{$t('news_latestnews')}}</h2>
                        
                    </div>
                    <div class="card p-0 border-0 mb-0">
                       <div class="card-body p-0 border-0  mb-0">
                           <div class="whiteBG p-3" v-if="localNewsData.length > 4">
	                            <div class="row py-3" :class="{'border-bottom': index < localNewsData.length-1}" v-for="list,index in localNewsData" v-if="index >= 4" :id="'four'+index">
                                    <div class="col-md-4 pr-2">
                                        <img :src="list.image" v-if="list.image">
                                        <img :src="getImage(list.tags,list.title,list._id)" v-else>
                                    </div>
                                    <div class="col-md-8 pl-2">
                                        <div class="d-flex justify-content-between incWdth">
                                            <div class="BlogTitleArea">
                                                <h4 class="RecordTitle BlogTitle mb-0" @click.prevent="singleNews = list;toDivElement('singleNews');lastId = 'four'+index">
                                                    <a href="#" class="green" v-html="list.title"></a>
                                                </h4>
                                            </div>
                                            
                                        </div>
                                        <div class="date d-flex align-items-center">
                                            {{dateFunction(list.created)}}
                                        </div> 
                                    </div>
                                </div>
                           </div>
                       </div>
                   </div>
                </div>


            </div>
        </div>
        
    </div>
</template>
<script>
	import moment from 'moment'
    import {fxViewMixins} from '@/plugins/fxView'
    export default {
        name: 'Market-News',
        mixins: [fxViewMixins],
        data() {
            return {
                showData : 'zero',
                col_span : 5,
				newsId : '',
				load_more_msz : false,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : 1,
				link : '',
                type:'all', //currency,stock market,commodity
                id:'',
                singleNews:{},
                lastId:'',
                localNewsData:[],
                imgData:{
                    "Currenc":{
                        "AUDUSD": 8,
                        "EURUSD": 11,
                        "GBPUSD": 10,
                        "NZDUSD": 8,
                        "USDCAD": 9,
                        "USDCHF": 7,
                        "USDJPY": 8
                    },
                    "Commodit":{
                        "GAS": 10,
                        "GOLD": 10,
                        "Oil": 10,
                        "Silver": 6
                    },
                    "Stock":{
                        "Stock": 5
                    }
                },
                imgIdList:{}
            }
        },
        methods:{
        	toDivElement(id){
                try{
                    setTimeout(function(){
                        var elmnt = document.getElementById(id);
                        elmnt.scrollIntoView();
                        document.getElementById(id).focus();
                        var top = $(window).scrollTop()
                        $(window).scrollTop(top-80)
                    }, 300);
                }catch(e){}
            },
            getImage(tags,titles,id){
                if(this.imgIdList.hasOwnProperty(id)){
                    return '../../../../static/fxView/images/news/'+this.imgIdList[id]+'.jpg'
                }
                let tag = (tags)?(tags.toLowerCase()):''
                let title = (titles)?(titles.toLowerCase()):''
                var name = '';
                for(let img in this.imgData){
                    if(tag.includes(img.toLowerCase())){
                        for(let curr in this.imgData[img]){
                            if(tag.includes(curr.toLowerCase())){
                                let length = this.imgData[img][curr];
                                let num = Math.floor(Math.random() * length) + 1;
                                name = curr+'/'+curr+'-'+num
                                break;
                            }else if(title.includes(curr.toLowerCase())){
                                let length = this.imgData[img][curr];
                                let num = Math.floor(Math.random() * length) + 1;
                                name = curr+'/'+curr+'-'+num
                                break;
                            }
                        }
                        if(name== ''){
                            var list = Object.keys(this.imgData[img])
                            let num1 = Math.floor(Math.random() * list.length);
                            let txt = ''
                            if(num1 < 1 || num1 > list.length-1){
                                txt = list[list.length-1]
                            }else{
                                txt = list[num1]
                            }
                            let num2 = Math.floor(Math.random() * this.imgData[img][txt]) + 1;
                            name = txt+'/'+txt+'-'+num2
                            // console.log(num1,txt,name)
                        }
                    }
                }
                if(!this.imgIdList.hasOwnProperty(id)){
                    this.imgIdList[id] = name
                }
                // console.log('../../../../static/fxview/images/news/'+name+'.jpg')
                return '../../../../static/fxView/images/news/'+this.imgIdList[id]+'.jpg'
            },
            tabFunc(getData){
                this.type = getData
                this.page = 1
                this.listing()
            },
            detailDiv(index, getData) {
				if(getData == 'more'){
					$(this.$refs['more'+index]).removeClass('hide');
					$(this.$refs['less'+index]).addClass('hide');
				}else{
					$(this.$refs['more'+index]).addClass('hide');
					$(this.$refs['less'+index]).removeClass('hide');
				}
            },
            loadList(){
				this.page = parseInt(this.page) + 1
				this.listing()
			},
			dateFunction(getDate){
				let last_seen_date = moment(new Date(getDate)).fromNow();
				return last_seen_date;
			},
			listing(){
				let inputJson = {
                    'globalParams' : {
    					filter: {},
    					sort: [],
    					search: this.search,
    					page: this.page,
                        indicator : this.type,
    					perPage: parseInt(this.pageLimit)
                    },
                    'localParams' : {'parameter' : this, page:'news', 'loaderFuncRun' : this.loaderFuncRun}
				}
				this._runGetCurrentNews(inputJson)
			},
            callGetDetail(list){
                if(list.source == 'FXS' && list.company == "" && this.newsDetail[list._id] != undefined){
                    this.getdetail(list._id)
                }else{
                    return
                }
            },
            getdetail(value){
                this.id = value
                let inputJson = {
                    'globalParams' : {
                        id : value
                    },
                    'localParams' : {'parameter' : this}
                }
                this._runGetCurrentNewsDetails(inputJson)
            }
        },
        created(){
            if(this.$route.query.id){
                if(this.currentNews.records){
                    let id = this.$route.query.id
                    let data = this.currentNews.records.filter(val=>id == val._id)
                    this.singleNews = (data.length > 0)?data[0]:{}
                    this.$router.push({query:{}})
                }
            }
        	if(this.currentNews.totalRecords > 0){
                this.loaderFuncRun = '0'
        		this.localNewsData = this.currentNews.records.slice(0,10)
        	}
			this.listing()
		}
    }
</script>
<style>
	.hide{
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/fxView/tradingtools/market_news.vue